/* eslint-disable import/prefer-default-export */
import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

type LoaderType = {
  height?: number;
  white?: boolean;
};

export const StyledLoader = styled.div<{ inline?: boolean }>`
  width: ${({ inline }) => !inline && "100%"};
  height: ${({ inline }) => !inline && "100%"};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledSpinner = styled.img<LoaderType>`
  height: ${({ height }) => (height ? `${height}em` : "2em")};
  width: ${({ height }) => (height ? `${height}em` : "2em")};
`;

export const StyledLoaderText = styled.p<LoaderType>`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSize.normal.desktop};
  color: ${({ theme, white }) =>
    white ? theme.colors.white : theme.colors.primaryTextColor};

  ${mediaMaxWidth.tablet} {
    font-size: ${({ theme }) => theme.fontSize.normal.mobile};
  }
`;

StyledLoader.displayName = "StyledLoader";
